import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function Placeholder({ title }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="h-full flex flex-col items-center justify-center text-[#004B87]/40">
      <SafeIcon icon="Cpu" className="text-4xl mb-4 opacity-50" />
      <h2 className="text-xl font-light uppercase tracking-widest mb-2">{title} Module</h2>
      <p className="text-xs font-mono uppercase">System component under construction</p>
      
      <div className="mt-8 w-64 h-1 bg-[#004B87]/10 relative overflow-hidden">
        <div className="absolute top-0 left-0 h-full bg-[#C1440E]/50 w-1/3 animate-pulse"></div>
      </div>
    </motion.div>
  );
}